<template>
  <pay-success :pay-amount="payAmount"></pay-success>
</template>

<script>
import PaySuccess from '@/components/order/PaySuccess';
export default {
  name: 'orderPaySuccess',
  components: {
    PaySuccess,
  },
  data() {
    return {
      payAmount: 0,
    };
  },
  onLoad(options) {
    const { payAmount } = options;
    this.payAmount = Number(payAmount);
  },
};
</script>

<style scoped></style>
